module.exports = __webpack_public_path__ + "img/projectList_bg8.9218272f.png";